import { ApiProperty } from '@nestjs/swagger';
import { IsNumber } from 'class-validator';

export class PlantInvoiceDetailsRequest {
    @ApiProperty()
    @IsNumber()
    saleOrderId?: number;

    @ApiProperty()
    financialYear?: string;

    @ApiProperty()
    tab?: string;

    @ApiProperty()
    unit?: number;

    @ApiProperty()
    fromDate?:Date

    @ApiProperty()
    toDate?:Date


    /**
     * @param saleOrderId
     * @param financialYear
    */
    constructor(saleOrderId?: number,financialYear?:string,tab?: string,unit?: number){
       this.saleOrderId=saleOrderId;
       this.financialYear = financialYear
       this.tab = tab
       this.unit = unit
    }
}    